import React from 'react';
import { RefreshCw } from 'lucide-react';
import './PullToRefresh.css';

/**
 * Componente visuale per pull-to-refresh
 */
const PullToRefreshIndicator = ({ pullDistance, isRefreshing, threshold = 80 }) => {
  const progress = Math.min((pullDistance / threshold) * 100, 100);
  const rotation = (pullDistance / threshold) * 360;
  const isActive = pullDistance > 0 || isRefreshing;

  return (
    <div 
      className={`pull-to-refresh-indicator ${isActive ? 'active' : ''}`}
      style={{
        transform: `translateY(${Math.min(pullDistance, threshold * 1.2)}px)`,
        opacity: isActive ? 1 : 0
      }}
    >
      <div className="pull-to-refresh-content">
        <RefreshCw
          className={`pull-to-refresh-icon ${isRefreshing ? 'spinning' : ''}`}
          style={{
            transform: isRefreshing ? 'rotate(0deg)' : `rotate(${rotation}deg)`
          }}
        />
        <div className="pull-to-refresh-progress">
          <svg width="48" height="48" viewBox="0 0 48 48">
            <circle
              className="pull-to-refresh-circle-bg"
              cx="24"
              cy="24"
              r="20"
              fill="none"
              stroke="#e5e7eb"
              strokeWidth="3"
            />
            <circle
              className="pull-to-refresh-circle"
              cx="24"
              cy="24"
              r="20"
              fill="none"
              stroke="#1b94ce"
              strokeWidth="3"
              strokeDasharray={`${2 * Math.PI * 20}`}
              strokeDashoffset={`${2 * Math.PI * 20 * (1 - progress / 100)}`}
              strokeLinecap="round"
            />
          </svg>
        </div>
        {!isRefreshing && pullDistance > 0 && (
          <p className="pull-to-refresh-text">
            {pullDistance >= threshold ? 'Rilascia per aggiornare' : 'Trascina per aggiornare'}
          </p>
        )}
        {isRefreshing && (
          <p className="pull-to-refresh-text">Aggiornamento...</p>
        )}
      </div>
    </div>
  );
};

export default PullToRefreshIndicator;
